import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconRadiusTopRight12 from './IconRadiusTopRight12';
import IconRadiusTopRight16 from './IconRadiusTopRight16';
import IconRadiusTopRight20 from './IconRadiusTopRight20';
import IconRadiusTopRight24 from './IconRadiusTopRight24';
import IconRadiusTopRight32 from './IconRadiusTopRight32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconRadiusTopRight = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconRadiusTopRight12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconRadiusTopRight16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconRadiusTopRight20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconRadiusTopRight24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconRadiusTopRight32 {...props} />}
        </span>
    );
};
IconRadiusTopRight.displayName = 'FondueIconRadiusTopRight';

export default memo(IconRadiusTopRight);
